import * as THREE from 'three'
import Experience from '../Experience'

export default class Desk {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources

    //options
    this.resource = this.experience.resources.items.desk
    this.macTexture = this.experience.resources.items.macScreen

    //methods
    this.setModel()
    this.setDeskMaterial()
    this.setScreenMaterial()
  }

  setModel() {
    //add model with "scene"
    this.model = this.resource.scene
    this.model.scale.set(0.9, 0.9, 0.9)
    // this.model.position.set(0, -3, -2)
    this.model.rotation.y = -Math.PI * 0.25
    this.model.position.set(-8, -2.5, 2)
    // this.model.rotation.x = Math.PI * 0.05

    this.model.castShadow = true
    this.model.receiveShadow = true
    this.scene.add(this.model)
  }
  setDeskMaterial() {
    //get texture
    this.deskTexture = this.experience.resources.items.bakedDesk
    this.deskTexture.flipY = false
    this.deskTexture.encoding = THREE.sRGBEncoding

    //setup material
    this.deskMaterial = new THREE.MeshBasicMaterial({ map: this.deskTexture })
    this.baked = this.model.children.find(child => child.name === 'merged')
    this.baked.material = this.deskMaterial
    this.baked.castShadow = true
    this.baked.receiveShadow = true
  }

  setScreenMaterial() {
    //get texture
    this.screenTexture = this.experience.resources.items.macScreen
    this.screenTexture.encoding = THREE.sRGBEncoding

    //setup material
    this.screenMaterial = new THREE.MeshBasicMaterial({ map: this.screenTexture })
    this.screen = this.model.children.find(child => child.name === 'screen')
    this.screen.material = this.screenMaterial
  }
}
